<script setup lang="ts">
import { ref, watch } from 'vue';
import { monogram } from '../../lib/format';

const props = withDefaults(defineProps<{ src?: string | null; name: string; size?: 'sm' | 'md' }>(), { src: null, size: 'sm' });

/** A Discord avatar that fails to load falls back to the monogram, not a gap. */
const broken = ref(false);
watch(() => props.src, () => { broken.value = false; });
</script>

<template>
  <span
    class="inline-flex shrink-0 items-center justify-center overflow-hidden rounded-full border border-card bg-raised text-darker"
    :class="size === 'md' ? 'size-9 text-[12px]' : 'size-6 text-[10px]'"
  >
    <img v-if="src && !broken" :src="src" :alt="''" class="size-full object-cover" loading="lazy" @error="broken = true" />
    <span v-else class="font-semibold tracking-wide">{{ monogram(name) }}</span>
  </span>
</template>
